/**
 * Authentication Layout Component
 * Layout for login/register pages
 */

import { RadarChartOutlined } from '@ant-design/icons';
import styles from './AuthLayout.module.css';

export default function AuthLayout({ children }) {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.header}>
          <div className={styles.logoContainer}>
            <RadarChartOutlined className={styles.logoIcon} aria-hidden="true" />
          </div>
          <h1 className={styles.title}>Map Collector</h1>
          <p className={styles.subtitle}>Global Location Intelligence</p>
        </div>
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
}

